//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'ProductCharacteristics',
  props: {
    reference: {
      type: String,
      default: null
    },
    parameters: {
      type: Object,
      default: null
    },
    zod: {
      type: Array,
      default: null
    },
    documents: {
      type: Array,
      default: null
    },
    isAlone: {
      type: Boolean,
      default: null
    },
    isMarketplace: {
      type: Boolean,
      default: null
    }
  },
  computed: {
    hasWeightParameter() {
      return !!(this.parameters && this.parameters.weight);
    },

    dimensionsParameters() {
      var height = this.parameters.height && this.$t('dimensions_height', {
        y: this.parameters.height
      });
      var width = this.parameters.width && this.$t('dimensions_width', {
        x: this.parameters.width
      });
      var depth = this.parameters.depth && this.$t('dimensions_depth', {
        z: this.parameters.depth
      });
      var dimensionList = [height, width, depth];
      return dimensionList.filter(Boolean).join(' x ');
    }

  },
  methods: {
    handleClick(evt, arg) {
      var result = {
        COVER: 'dimensions',
        TECHNICAL: 'document_technique',
        ASSEMBLY: 'telecharger_notice_montage'
      };
      this.$root.$emit('generic-tracking', evt, {
        data: {
          event_category: 'FicheProduit',
          event_action: "Clic_".concat(result[arg.type]),
          event_label: "".concat(window.tc_vars.product_activity, "/").concat(window.tc_vars.page_cat2, "/").concat(window.tc_vars.page_cat3, "/").concat(window.tc_vars.page_cat4, "/").concat(window.tc_vars.page_cat5)
        }
      });
    }

  }
};